module.exports = "../../../../platform/assets/pageMainIcon/simple_yewushezhilei8.svg";